import React, { Component, Fragment } from "react";
import { Footer } from "../general";
import { ModernHeader } from "../modern";

export class Contacto extends Component {
  render = () => {
    return (
      <Fragment>
        <ModernHeader />
        <div className="modern-service-page">
          {/* Hero Section */}
          <div className="modern-service-hero">
            <div className="auto-container">
              <h1 className="animate-fade-in-up">Contacto</h1>
              <p
                className="subtitle animate-fade-in-up"
                style={{ animationDelay: "0.2s" }}
              >
                Ponte en contacto con nosotros para recibir asesoría
                personalizada
              </p>
            </div>
          </div>

          {/* Contact Info Section */}
          <div className="auto-container">
            <div className="modern-contact-section">
              <div className="row">
                <div className="col-lg-12">
                  <div className="modern-contact-info">
                    <h2 className="animate-fade-in-up">
                      ¿Cómo podemos ayudarte?
                    </h2>
                    <p
                      className="animate-fade-in-up"
                      style={{ animationDelay: "0.1s" }}
                    >
                      Nuestro equipo de expertos está listo para brindarte la
                      mejor asesoría contable y tributaria. Contáctanos a través
                      de cualquiera de nuestros canales disponibles.
                    </p>

                    <div className="contact-cards-grid">
                      <div
                        className="contact-card animate-fade-in-up"
                        style={{ animationDelay: "0.2s" }}
                      >
                        <div className="contact-card-icon">
                          <i className="fas fa-envelope"></i>
                        </div>
                        <div className="contact-card-content">
                          <h4>Email</h4>
                          <p>Escríbenos y te responderemos pronto</p>
                          <a
                            href="mailto:contacto@contasi.cl"
                            className="contact-link"
                          >
                            contacto@contasi.cl
                          </a>
                        </div>
                      </div>

                      <div
                        className="contact-card animate-fade-in-up"
                        style={{ animationDelay: "0.3s" }}
                      >
                        <div className="contact-card-icon">
                          <i className="fas fa-phone"></i>
                        </div>
                        <div className="contact-card-content">
                          <h4>Teléfonos</h4>
                          <p>Llámanos durante horario de oficina</p>
                          <div className="phone-numbers">
                            <a href="tel:+56961922323" className="contact-link">
                              +56 9 6192 2323
                            </a>
                            <a href="tel:+323468722" className="contact-link">
                              32-3468722
                            </a>
                          </div>
                        </div>
                      </div>

                      <div
                        className="contact-card animate-fade-in-up"
                        style={{ animationDelay: "0.4s" }}
                      >
                        <div className="contact-card-icon">
                          <i className="fab fa-whatsapp"></i>
                        </div>
                        <div className="contact-card-content">
                          <h4>WhatsApp</h4>
                          <p>Chatea con nosotros en tiempo real</p>
                          <a
                            href="https://wa.me/56961922323"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="contact-link whatsapp-link"
                          >
                            Iniciar chat
                          </a>
                        </div>
                      </div>

                      <div
                        className="contact-card animate-fade-in-up"
                        style={{ animationDelay: "0.5s" }}
                      >
                        <div className="contact-card-icon">
                          <i className="fas fa-clock"></i>
                        </div>
                        <div className="contact-card-content">
                          <h4>Horarios</h4>
                          <p>Lunes a Viernes: 9:00 a 19:00 hrs</p>
                          <p className="closed-info">
                            Sábados, Domingos y Festivos: Cerrado
                          </p>
                        </div>
                      </div>

                      <div
                        className="contact-card animate-fade-in-up"
                        style={{ animationDelay: "0.6s" }}
                      >
                        <div className="contact-card-icon">
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div className="contact-card-content">
                          <h4>Ubicación</h4>
                          <p>Oficina Viña del Mar</p>
                          <p className="address">12 Norte 785, Of. 406</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Map Section */}
              <div
                className="modern-map-section animate-fade-in-up"
                style={{ animationDelay: "0.7s" }}
              >
                <h3>Nuestra Ubicación</h3>
                <div className="map-container">
                  <iframe
                    title="mapa contacto"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3345.7267056799105!2d-71.54809999999999!3d-33.010979999999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9689ddc29bb2cb25%3A0x4c498f37f9340793!2s12%20Nte.%20785%2C%202531172%20Valpara%C3%ADso%2C%20Vi%C3%B1a%20del%20Mar%2C%20Valpara%C3%ADso!5e0!3m2!1sen!2scl!4v1683141230837!5m2!1sen!2scl"
                    allowFullScreen
                    loading="lazy"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </Fragment>
    );
  };
}

export default Contacto;
